// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var Utilities = (function () {
    function Utilities() {
    }
    Utilities.appendTrailingSlash = function (url) {
        return url.charAt(url.length - 1) === "/" ? url : url + "/";
    };
    return Utilities;
}());
exports.__esModule = true;
exports["default"] = Utilities;



//////////////////
// WEBPACK FOOTER
// ./Base/Utilities.ts
// module id = 15
// module chunks = 0